import {
  GET_EMAREGULATION_FAIL,
  GET_EMAREGULATION_SUCCESS,
  GET_EMAREGULATIONS_FAIL,
  GET_EMAREGULATIONS_SUCCESS,
  ADD_EMAREGULATION_SUCCESS,
  ADD_EMAREGULATION_FAIL,
  UPDATE_EMAREGULATION_SUCCESS,
  UPDATE_EMAREGULATION_FAIL,
  DELETE_EMAREGULATION_SUCCESS,
  DELETE_EMAREGULATION_FAIL,  
  SET_STATE_EMAREGULATION
} from "./actionTypes";

const INIT_STATE = {
  emaRegulations: [],
  emaRegulation: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const emaRegulations = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMAREGULATIONS_SUCCESS:
      return {
        ...state,
        emaRegulations: action.payload.emaRegulations,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_EMAREGULATION:
      return { ...state, loading: action.payload }

    case GET_EMAREGULATIONS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_EMAREGULATION_SUCCESS:
      return {
        ...state,
        emaRegulations: [...state.emaRegulations, action.payload],
      };

    case ADD_EMAREGULATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_EMAREGULATION_SUCCESS:
      return {
        ...state,
        emaRegulations: state.emaRegulations.map(emaRegulation =>
          emaRegulation.id.toString() === action.payload.id.toString()
            ? { ...action.payload, emaRegulation }
            : emaRegulation
        ),
      };

    case UPDATE_EMAREGULATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_EMAREGULATION_SUCCESS:
      return {
        ...state,
        emaRegulations: state.emaRegulations.filter(
          emaRegulation => emaRegulation.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_EMAREGULATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_EMAREGULATION_SUCCESS:
      return {
        ...state,
        emaRegulation: action.payload,
      };

    case GET_EMAREGULATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default emaRegulations;
